import moment from "moment";
import React, { Component } from "react";
import constant from "../../constant";
import { getStorage } from "../../utils";
import logo from './../../assets/images/logo-f.png';
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: getStorage(constant.keys.userDetails),
      MasterData: undefined,
    };
  }
  componentDidMount() {

  }

  render() {
    const { MasterData } = this.state;
    const { details } = this.state;
    return (
      <React.Fragment>
        <footer>
          <section className="footer-top-wrap">
            <div className="container">
              <div className="row">
                <div className="single-item col-lg-3 col-md-6 col-12">
                  <div className="footer-box">
                    <div className="footer-logo">
                      <a href="">
                        <img
                          src={logo}
                          className="img-fluid"
                          alt="footer-logo"
                        />
                      </a>
                      <p>Corporate office: Koramangala, Bengaluru</p>
                    </div>


                  </div>
                </div>
                <div className="single-item col-lg-3 col-md-6 col-12">
                  <div className="footer-box">
                    <div className="footer-header">
                      <h3>Recruitment Solutions</h3>
                    </div>
                    <div className="footer-departments">
                      <ul>

                        {/* <li>
                          <Link to={constant.component.JobPosting.url}>Job Posting</Link>
                        </li>
                        <li>
                          <a href="https://manpower.mindclick.co.in/">HR/MAN Power Outsourcing</a>
                        </li>
                        <li>
                          <a href="https://gift.mindclick.co.in/">Corporate Gifting</a>
                        </li>
                        <li>
                          <a href="https://mindclick.co.in/">Events & Entertainment</a>
                        </li> */}

                        <li><a id='linked-in' href={constant.component.JobPosting.url}>Job Posting</a></li>
                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">CRM</a></li>
                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">Corporate Training</a></li>
                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">Campus Hiring</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="single-item col-lg-3 col-md-6 col-12">
                  <div className="footer-box">
                    <div className="footer-header">
                      <h3>Information</h3>
                    </div>
                    <div className="footer-quick-link">
                      <ul>
                        <li>
                          <a target="_blank" href={'https://jobzshala.com/about-us'}>About Us</a>
                        </li>
                        <li>
                          <a href="https://jobzshala.com/blog">Blog</a>
                        </li>
                        <li>
                          <a target="_blank" href="https://jobzshala.com/">Jobseeker Home</a>
                        </li>
                        <li>
                          <a href="https://jobzshala.com/faq">FAQs</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="single-item col-lg-3 col-md-6 col-12">
                  <div className="footer-box">
                    <div className="footer-header">
                      <h3>Legal</h3>
                    </div>
                    <div className="footer-quick-link">
                      <ul>
                        <li>
                          <a href=""> Privacy Policy</a>
                        </li>
                        <li>
                          <a href=""> User Terms & Conditions</a>
                        </li>
                        <li>
                          <a href="">Employer Terms of Service</a>
                        </li>

                        <li>
                          <a href="">
                            Community Guidelines</a>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
          <section className="footer-center-wrap">
            <div className="container">
              <div className="row no-gutters">
                <div className="col-lg-4 col-12">
                  <div className="footer-social">
                    <ul>
                      <li>Follow Us:</li>
                      <li>
                        <a href="#">
                          <i className="fa fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-pinterest-p" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-skype" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </section>
          <section className="footer-bottom-wrap">
            <div className="copyright">
              Copyright @ {moment().format('YYYY')} <a target="_blank" href="https://www.jobzshala.com" rel="nofollow">JobzShala.</a> All Rights Reserved.
              {/* <a target="_blank" href="https://www.jobzshala.com" rel="nofollow">
                JobzShala
              </a> */}
            </div>
          </section>
        </footer>


      </React.Fragment>
    );
  }
}
